


































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { ExtraFields } from '@/models/ExtraFields'
import { ExtraFieldCodeEnum } from '@/enum/ExtraFieldsCodeEnum'
import { Dictionary } from '@/dictionary/Dictionary'
import { servicesCode, servicesDict } from '@/dictionary/ServicesDict'
import { deliveryAddCostTypes } from '@/dictionary/DeliveryAddCostTypeDict'
import { orderTypeDict } from '@/dictionary/OrderTypeDict'
import { getDefaultAccountOptions, getEmptyExtraFields } from '@/components/helper'
import AccountOptions from '@/models/AccountOptions'
import Package from '@/api/models/Package';
import { ListElement } from '@/api/models/ListElement'
import { contragentTypeDict } from '@/dictionary/ContragentType'

@Component
export default class ExtraFieldsComponent extends Vue {
    @Prop({ type: Object, default: () => ({}) })
    private currentExtraFields!: ExtraFields

    @Prop({ type: Object, default: () => ({}) })
    private currentAccountOptions: AccountOptions

    @Prop({ type: Object, default: () => ({}) })
    private accountOptions: AccountOptions

    @Prop({ type: Array, default: () => [] })
    private cdekPackages: Array<Package>

    private selectedExtraField: ExtraFields = getEmptyExtraFields()
    private selectedAccountOptions: AccountOptions = getDefaultAccountOptions()
    private localExecutorsList: Array<ListElement> = []
    private error = ''

    @Watch('currentExtraFields')
    currentExtraFieldsUpdate() {
        this.selectedExtraField = Object.assign({}, this.currentExtraFields)
    }

    @Watch('currentAccountOptions')
    selectedOptions(): void {
        this.selectedAccountOptions = Object.assign({}, this.currentAccountOptions)
        let ind = 0;
        for (const name of Object.values(this.selectedAccountOptions.customExecutorsList.value as Array<string>)) {
            this.localExecutorsList.push({
                value: name,
                index: ind
            } as ListElement)
            ind++
        }
    }

    get services(): Array<Dictionary> {
        const enable = this.accountOptions?.enableLoadingOperations?.value === true
        if (enable) {
            return servicesDict
        }
        const exclude: string[] = [
            servicesCode.GET_UP_FLOOR_BY_HAND,
            servicesCode.GET_UP_FLOOR_BY_ELEVATOR,
            servicesCode.LOADING_OPERATIONS_AT_THE_SENDER,
            servicesCode.LOAD_THE_OPERATION_AT_THE_RECIPIENT
        ]
        return servicesDict.filter(s => !exclude.includes(s.code))
    }

    get contragentTypeDict(): Array<Dictionary> {
        return contragentTypeDict
    }

    get orderTypes(): Array<Dictionary> {
        return orderTypeDict;
    }

    get shipmentExecutorsList(): Array<Dictionary> {
        const arr = this.accountOptions.customExecutorsList?.value as Array<string> ?? []
        return arr.map((item: string) => {
            return {
                code: item,
                name: item
            } as Dictionary
        }) as Array<Dictionary>
    }

    modelCallback(field: string): boolean {
        const values = this.selectedExtraField.deliveryExtraDataServices.value as Array<string>
        return !!values.find(value => value === field)
    }

    change(field: string): void {
        this.clearError()
        const values = this.selectedExtraField.deliveryExtraDataServices.value as Array<string>
        const nonExistValue = !values.find(value => value === field)

        if (nonExistValue) {
            if (this.isExistIncompatibleServices(values, field)) {
                this.error = this.$t('settings.extraFields.incompatibleServicesText').toString()
                return
            }
            values.push(field)
        } else {
            const index = values.findIndex(value => value === field)
            values.splice(index, 1)
        }

        this.updateExtraFields(ExtraFieldCodeEnum.deliveryExtraDataServices)
    }

    private isExistIncompatibleServices(selectedServices: Array<string>, serviceCode: string): boolean {
        const banAttachmentService = selectedServices.find((item) => item === servicesCode.BAN_ATTACHMENT_INSPECTION)
        let isExist = false

        if (
            banAttachmentService &&
            (serviceCode === servicesCode.PART_DELIV || serviceCode === servicesCode.TRYING_ON)
        ) {
            isExist = true
        } else {
            const services = selectedServices.find(
                (item) => item === servicesCode.PART_DELIV || item === servicesCode.TRYING_ON
            )
            if (services && serviceCode === servicesCode.BAN_ATTACHMENT_INSPECTION) {
                isExist = true
            }
        }

        return isExist
    }

    validateAddCost(): string {
        const type = this.selectedExtraField.deliveryExtraDataAddCostType.value as string
        const cost = Math.round(this.selectedExtraField.deliveryExtraDataAddCost.value as number)
        if (
            type === deliveryAddCostTypes.PERCENT &&
            (cost > 100 || cost < 0)
        ) {
            return this.$t('settings.extraFields.deliveryAddCostType.errorUpdateCost').toString()
        }

        return '';
    }

    changePackageTypeData(): void {
        this.clearError()
        const amount = this.selectedExtraField.cdekPackageAmount.value as number
        this.selectedExtraField.cdekPackageAmount.value = amount

        this.updateExtraFields(ExtraFieldCodeEnum.cdekPackageAmount)
        this.updateExtraFields(ExtraFieldCodeEnum.cdekPackageType)
    }

    changeOrderTypeData(): void {
        this.clearError()

        this.updateExtraFields(ExtraFieldCodeEnum.orderType)
    }

    changeContragentSenderType(): void {
        this.updateExtraFields(ExtraFieldCodeEnum.senderContragentType)
    }

    changeContragentRecipientType(): void {
        this.updateExtraFields(ExtraFieldCodeEnum.recipientContragentType)
    }

    changeAddComment(): void {
        this.updateExtraFields(ExtraFieldCodeEnum.deliveryExtraDataAddOrderComment)
    }

    changeConsolidatedShipment(): void {
        this.updateExtraFields(ExtraFieldCodeEnum.shipmentExtraDataConsolidatedShipment)
    }

    changeRequestToCourier(): void {
        this.updateExtraFields(ExtraFieldCodeEnum.shipmentExtraDataRequestToCourier)
    }

    changeShipmentExecutor(): void {
        this.updateExtraFields(ExtraFieldCodeEnum.shipmentExtraDataExecutor)
    }

    updateExtraFields(fieldCode: string): void {
        this.$emit('updateExtraFields', this.selectedExtraField[fieldCode])
    }

    addExecutor(): void {
        this.localExecutorsList.push({
            value: '*Новый исполнитель*',
            index: this.localExecutorsList.length
        } as ListElement);
    }

    removeExecutor(idx: number): void {
        this.localExecutorsList.splice(idx, 1);
        this.saveExecutorList()
    }

    saveExecutorList(): void {
        this.selectedAccountOptions.customExecutorsList.value = this.localExecutorsList.map((elem: ListElement) => {
            return elem.value
        });
        this.$emit('updateAccountOptionEvent', this.selectedAccountOptions.customExecutorsList)
    }

    clearError(): void {
        this.error = ''
    }

    validateExecutor(elem: ListElement): void {
        if (elem.value.length > 0) {
            this.saveExecutorList()
        }
    }

    getErrorName(name: string) {
        if (name.length < 1) {
            return 'Поле не должно быть пустым!';
        }

        return false;
    }

    get isEnableCdekPackage(): boolean {
        return this.accountOptions.enableCdekPackage.value === true
    }

    get isEnableOrderType(): boolean {
        return this.accountOptions.enableOrderType.value === true
    }
}
